import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

/**
 * Container component that provides a centered, width-limited wrapper
 * Uses our custom grid system classes
 */
const Container = ({
  children,
  className,
  fluid = false,
  as: Component = 'div',
  ...rest
}) => {
  const containerClass = fluid ? 'container-fluid' : 'container';

  return (
    <Component className={cx(containerClass, className)} {...rest}>
      {children}
    </Component>
  );
};

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  fluid: PropTypes.bool,
  as: PropTypes.elementType,
};

export default Container;
